<template>
<v-flex mb-5 align-self-start>

    <v-layout px-3 my-5 align-center>
        <h1 class="text-xs-left display-2 my-2">Parents</h1>
        <v-spacer></v-spacer>
        <!-- <v-btn class="green white--text" @click="initCreate = true">Create Parent</v-btn> -->
    </v-layout>

    <parents-data-table></parents-data-table>

    <!-- <v-dialog v-model="initCreate" max-width="500px">
      <create-parent-form
      	:active="initCreate"
      	@close="initCreate = false">
      </create-parent-form>
    </v-dialog> -->

</v-flex>
</template>

<script>
import DataTable from './DataTable'
// import CreateForm from './CreateForm'

export default {
    components: {
        ParentsDataTable: DataTable,
        // CreateParentForm: CreateForm
    },
    data() {
        return {
            initCreate: false
        }
    },
    created() {
        this.$store.dispatch('getParents')
    }
}
</script>
